import { useMemo } from 'react'
import { View } from 'react-native'

import { Header, type THeaderProps } from '@/src/elements/header'
import { Placeholder, PlaceholderLine } from '@/src/elements/placeholder'
import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { useRoutes } from '@/src/general/utils/routes'

import { PublicationContentPlaceholder } from './PublicationContentPlaceholder'

export const PublicationLoadingScreen = () => {
  const { data: me } = useMeQuery()
  const { routes } = useRoutes()
  const { handleBackPress } = useBackHandlePress(me ? routes['prayer-space']() : routes.communities())

  // If coming from another page of the site, the 'back' button should allow you to return to the previous page.
  const leftButtons: THeaderProps['leftButtons'] = useMemo(
    () => [
      {
        startIcon: ICON.ARROW_LEFT,
        onPress: handleBackPress,
        type: 'icon',
      },
    ],
    [handleBackPress],
  )

  const rightButtons: THeaderProps['rightButtons'] = useMemo(
    () => [
      {
        type: 'icon',
        startIcon: ICON.SHARE,
        disabled: true,
      },
      {
        type: 'icon',
        startIcon: ICON.ELLIPSIS_HORIZONTAL,
        disabled: true,
      },
    ],
    [],
  )

  return (
    <View className="flex-1 items-center justify-start" testID={TEST_ID.PUBLICATION.SCREEN.LOADING}>
      <Header
        communityInfos={{ variant: 'onGroup', isLoading: true }}
        leftButtons={leftButtons}
        rightButtons={rightButtons}
      />
      <View className="flex-column mx-auto flex w-full max-w-screen-md gap-4 px-5">
        <Placeholder noBackground className="flex-col gap-4 px-0 py-0">
          <PlaceholderLine size="lg" className="my-10" length="half" />
        </Placeholder>
        <PublicationContentPlaceholder />
      </View>
    </View>
  )
}
